import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ModalBody from '../../Modal/ModalBody';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';

// TODO(SFH order history screen): replace this placeholder with the real
// order-history timeline once the design and the backend events feed land.

const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${pxToRem(240)};
  padding: ${pxToRem(24)};
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(14)};
  color: ${themeColors.colorTextSecondary};
  text-align: center;
`;

const SellFromHomeTransactionHistory = () => {
  const { t } = useTranslation();

  return (
    <ModalBody>
      <Placeholder>
        {t('sellWizard.sfhWizard.transactionHistory.placeholder')}
      </Placeholder>
    </ModalBody>
  );
};

export default SellFromHomeTransactionHistory;
